import type { FloorInventoryIdsSource } from "./getFloorInventoryIdsForSelection.function";

export type FloorSelectableSource = FloorInventoryIdsSource & {
  numberOfFilterMatchedObjects?: number;
  numberOfBookableObjects?: number;
  occupiedInventoryIds: number[];
  forbiddenInventoryIds: number[];
};

/**
 * Whether a floor row in the floor filter list should stay clickable.
 * Filter matches count even when only inactive inventories match (admin early-filter flow).
 * Tandem-blocked inventory is not bookable on the plan but must not grey-out the floor.
 */
export function floorHasSelectableInventory(
  floor: FloorSelectableSource,
  allowInactiveResourceBooking = false
): boolean {
  if ((floor.numberOfFilterMatchedObjects ?? 0) > 0) {
    return true;
  }
  if ((floor.numberOfBookableObjects ?? 0) > 0) {
    return true;
  }

  const blockedInventoryIds = floor.blockedInventoryIds ?? [];
  const inventoryIdsOnFloor = [
    ...floor.availableInventoryIds,
    ...floor.occupiedInventoryIds,
    ...floor.forbiddenInventoryIds,
    ...blockedInventoryIds,
    ...(allowInactiveResourceBooking ? floor.disabledInventoryIds : [])
  ];

  if (allowInactiveResourceBooking) {
    return inventoryIdsOnFloor.length > 0;
  }

  return (
    [
      ...floor.availableInventoryIds,
      ...floor.occupiedInventoryIds,
      ...floor.disabledInventoryIds,
      ...floor.forbiddenInventoryIds,
      ...blockedInventoryIds
    ].length > 0
  );
}
